var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgColumnBar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 13,
  width: 5,
  height: 19,
  className: "chart-qualitative-01"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 9,
  width: 5,
  height: 32,
  className: "chart-qualitative-01"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 18,
  y: 8,
  width: 5,
  height: 24,
  className: "chart-qualitative-01"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 27,
  y: 25,
  width: 5,
  height: 7,
  className: "chart-qualitative-01"
})));
export { SvgColumnBar as ReactComponent };
export default __webpack_public_path__ + "column_bar.2e27af084090a18b014f54fd1122faa3.svg";